/**
 * Bonding curve и системные константы.
 *
 * ВНИМАНИЕ: эти значения дублируются в Tact-контрактах.
 * При изменении — обновить в обоих местах одновременно.
 */

// 1 TON = 10^9 nanoTON
export const NANO = 10n ** 9n;

// Jetton имеет 9 decimals (стандарт TON)
export const JETTON_DECIMALS = 9;
export const JETTON_UNIT = 10n ** BigInt(JETTON_DECIMALS);

// === Bonding Curve params (по умолчанию, как pump.fun / Blum) ===

/** Total supply: 1B */
export const TOTAL_SUPPLY = 1_000_000_000n * JETTON_UNIT;

/** На bonding curve доступно к торговле: 800M */
export const CURVE_SUPPLY = 800_000_000n * JETTON_UNIT;

/** Зарезервировано на DEX-миграцию: 200M */
export const MIGRATION_RESERVE = 200_000_000n * JETTON_UNIT;

/** Начальные виртуальные TON-резервы (определяют initial price): 30 TON */
export const VIRTUAL_TON_INIT = 30n * NANO;

/** Дефолтный target для graduation: 500 TON собрано на curve (cohort 1). */
export const DEFAULT_TARGET_TON = 500n * NANO;

// === Cohort 1 (skip-audit) factory caps ===
// Дублируется в factory.tact в init(). При изменении синхронизировать.

/** Совокупный target_TON всех токенов в cohort 1: 5000 TON. */
export const COHORT_1_TVL_CAP = 5000n * NANO;

/** Максимум развёрнутых токенов в cohort 1. */
export const COHORT_1_MAX_DEPLOYMENTS = 100n;

/** Минимальный target_TON для нового токена в cohort 1: 100 TON. */
export const COHORT_1_MIN_TARGET = 100n * NANO;

/** Максимальный target_TON для нового токена в cohort 1: 1000 TON. */
export const COHORT_1_MAX_TARGET = 1000n * NANO;

/** Protocol fee на каждый buy/sell: 100 bps = 1% */
export const PROTOCOL_FEE_BPS = 100n;
export const BPS_DENOM = 10000n;

/** Гарантированный gas reserve в каждом swap-сообщении */
export const SWAP_GAS_RESERVE = 50_000_000n; // 0.05 TON

/** Forward TON для уведомления получателя при transfer (TEP-74) */
export const FORWARD_TON_AMOUNT = 10_000_000n; // 0.01 TON

// === Factory params ===

/** Минимальный value для DeployToken вызова */
export const FACTORY_DEPLOY_VALUE = 500_000_000n; // 0.5 TON

// === Anti-spam ===

/** Free tier: 1 launch / 24h */
export const RATE_LIMIT_FREE_DAILY = 1;
export const RATE_LIMIT_TTL_SECONDS = 86_400;

/** После rejected launch'а тикер заблокирован 30 мин (anti-griefing) */
export const TICKER_RESERVATION_TTL = 1_800;

/** Image moderation thresholds */
export const NSFW_THRESHOLD = 0.7;
export const VIOLENCE_THRESHOLD = 0.7;

/** Max ticker length */
export const MIN_TICKER_LEN = 2;
export const MAX_TICKER_LEN = 10;
export const TICKER_REGEX = /^[A-Z][A-Z0-9]{1,9}$/;

/** Description max len */
export const MAX_DESCRIPTION_LEN = 200;

// === Timeouts ===

/** Indexer wait для TokenDeployed event */
export const DEPLOY_EVENT_TIMEOUT_MS = 15_000;

/** Worker job timeout */
export const LAUNCH_JOB_TIMEOUT_MS = 60_000;
